import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['day']
  static values = { date: String }

  connect() {
    useDispatch(this, { eventPrefix: false })
    window.addEventListener(`${this.dateValue}Selected`, this.highlight.bind(this))
    window.addEventListener('calendardayDeselected', this.removeHighlight.bind(this))
  }

  disconnect() {
    window.removeEventListener(`${this.dateValue}Selected`, this.highlight.bind(this))
    window.removeEventListener('calendardayDeselected', this.removeHighlight.bind(this))
  }

  highlight() {
    this.dispatch('calendardayDeselected')
    this.dayTarget.classList.add('bg-gray-mid')
  }

  removeHighlight() {
    this.dayTarget.classList.remove('bg-gray-mid')
  }
}
